var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-pool",style:(_vm.customStyle)},[_c('generic-html',{attrs:{"component":_vm.htmlComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }